import React from 'react';
import ProgressBar from '@Common/quillElements/spinner/Progressbar';

export default function LoadBar(props) {
  const [progress, setProgress] = React.useState(0);
  let vel = 1.7;
  let accel = 0.71;
  React.useEffect(() => {
    if (props.loading) {
      const timer = setInterval(() => {
        setProgress((oldProgress) => {
          if (props.loading) {
            vel += accel;
            if (Math.abs(vel) > 5) {
              accel = 0;
            }
            if (oldProgress > 99) {
              vel = 0;
            } else if (oldProgress > 95) {
              vel = 0.2;
            }
            return Math.min(oldProgress + vel, 100);
          }
          return 0;
        });
      }, 100);
      return () => {
        clearInterval(timer);
      };
    }
    vel = 1.7;
    accel = 0.71;
    if (progress) {
      setProgress(100);
      setTimeout(() => {
        setProgress(0);
      }, 400);
    }
  });

  return (
    <ProgressBar
      variant="determinate"
      style={{
        ...props.style,
        visibility: progress > 0 ? 'visible' : 'hidden',
      }}
      value={progress}
    />
  );
}
